"use client";
import React from "react";
import MuxPlayer from "components/Tiles/commonComponents/MuxPlayer";
// AtomParts/Video.tsx
interface VideoProps {
  id: string;
}

const VideoPlayer: React.FC<VideoProps> = ({ id }) => {
  return (
    <MuxPlayer
      streamType="on-demand"
      playbackId={id}
      loop
      muted
      autoPlay
      className="border-primary-[#E8ECED] z-10  h-full w-full overflow-hidden rounded-xl rounded-b-none border object-cover"
    />
  );
};

export default VideoPlayer;
